module.exports = __webpack_public_path__ + "static/img/trading-3.4999990.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/trading-3.png
// module id = XEFO
// module chunks = 1